export default {
  dnvDisplay: `'DNV Display'`,
  gantari: `Gantari, Helvetica, Arial, ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'`,
  mono: `ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace;`,
} as const
